import React, { useEffect } from 'react'
import avtar2 from '../../assets/images/user/avatar-2.jpg'
import { Link, useNavigate } from 'react-router-dom'
import { useProfile } from '../Context/ProfileContext';
import { imgUrl } from '../Services/api';
const Header = ({ onToggleSidebar }) => {
    const { profile, fetchProfile } = useProfile();

    const navigate = useNavigate();
    const handleLogout = async () => {
        localStorage.removeItem("token");
        localStorage.clear()
        navigate('/login')
    }
    useEffect(() => {
        fetchProfile();
    }, [])
    return (
        <>
            <header className="pc-header border">
                <div className="header-wrapper">
                    <div className="me-auto pc-mob-drp">
                        <ul className="list-unstyled">
                            <li className="pc-h-item pc-sidebar-collapse">
                                <Link to="#" className="pc-head-link ms-0" id="sidebar-hide" onClick={onToggleSidebar}>
                                    <i className="fas fa-bars" />
                                </Link>
                            </li>
                            <li className="pc-h-item pc-sidebar-popup">
                                <Link to="#" className="pc-head-link ms-0" id="mobile-collapse" onClick={onToggleSidebar}>
                                    <i className="fas fa-bars" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="ms-auto">
                        <ul className="list-unstyled">
                            <li className="dropdown pc-h-item header-user-profile">
                                <a
                                    className="pc-head-link dropdown-toggle arrow-none me-0"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-haspopup="false"
                                    data-bs-auto-close="outside"
                                    aria-expanded="false"
                                >
                                    <img
                                        src={profile.profileImage ? `${profile?.profileImage}` : avtar2}
                                        alt="user-image"
                                        className="user-avtar"
                                    />
                                </a>
                                <div className="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                                    <div className="dropdown-header d-flex align-items-center justify-content-between">
                                        <h5 className="m-0">Profile</h5>
                                    </div>
                                    <div className="dropdown-body">
                                        <div
                                            className="profile-notification-scroll position-relative"
                                            style={{ maxHeight: "calc(100vh - 225px)" }}
                                        >
                                            <div className="d-flex mb-1">
                                                <div className="flex-shrink-0">
                                                    <img
                                                        src={profile.profileImage ? `${profile?.profileImage}` : avtar2}
                                                        alt="user-image"
                                                        className="user-avtar wid-35"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h6 className="mb-1">{profile?.fullName} 🖖</h6>
                                                    <span>{profile?.email}</span>
                                                </div>
                                            </div>
                                            <hr className="border-secondary border-opacity-50" />
                                            <p className="text-span">Settings</p>
                                            <Link to="/profile" className="dropdown-item">
                                                <span>
                                                    <i className='fas fa-user pc-icon text-muted me-2'></i>
                                                    <span>Profile</span>
                                                </span>
                                            </Link>
                                            <hr className="border-secondary border-opacity-50" />
                                            <div className="d-grid mb-3">
                                                <button className="btn btn-primary" onClick={handleLogout}>
                                                    <i className="fas fa-right-from-bracket pc-icon me-2"></i>
                                                    Logout
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header